import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { RetailTableDataService } from "./retail-table-data.service";
import { TableDataModule } from "app_quotation/shared/services/table-data/table-data.module";

@NgModule({
    imports: [
        CommonModule,
        TableDataModule,
    ],
    providers: [
        RetailTableDataService
    ],
})
export class RetailTableDataModule {
}
